// src/hooks/useService.ts

import { useQuery } from "@tanstack/react-query";
import { IService } from "../../interfaces/IService";
import { customFetcher } from "../useFetch";
import { IServiceCategory } from "../../interfaces/IServiceCategory";

//
// Fetch alle Services
//
export const useGetServices = () => {
    const {
        data: serviceArray = [],
        isLoading: isLoadingServices,
        error: errorServices,
        refetch: refetchServices,
    } = useQuery<IService[], Error>({
        queryKey: ["service/"],
        queryFn: () =>
            customFetcher({
                endpoint: "/service/",
            }),
        refetchOnWindowFocus: false,
        initialData: [],
    });

    return {
        serviceArray,
        isLoadingServices,
        errorServices,
        refetchServices,
    };
};

//
// Fetch alle Service-Kategorien
//
export const useGetServiceCategories = () => {
    const {
        data: serviceCategoryArray = [],
        isLoading: isLoadingServiceCategories,
        error: errorServiceCategories,
        refetch: refetchServiceCategories,
    } = useQuery<IServiceCategory[], Error>({
        queryKey: ["servicecategory/"],
        queryFn: () =>
            customFetcher({
                endpoint: "/servicecategory/",
            }),
        refetchOnWindowFocus: false,
        initialData: [],
    });

    return {
        serviceCategoryArray,
        isLoadingServiceCategories,
        errorServiceCategories,
        refetchServiceCategories,
    };
};
